import { PacketValueSerialType } from "../../../enum/PacketValueSerialType";
import { Input, KeyCode } from "../../../lib/Input";
import Ability from "../../Ability";
import Player from "../../Player";

export default class SensorSweep extends Ability {
    targets: Player[]|undefined;

    constructor(player: Player) {
        super(player, {
            cooldown: 18,
            duration: 5,
            energyCost: 25,
            icon: 10,
            trigger: KeyCode.Digit2,
            triggerType: Input.GetKeyDown,
            info: `Sensor Sweep (18s cooldown) - Reveals all enemies to your team for 5 seconds`
        })
    }

    onDurationEnd(): void {
        if (!this.targets) return;

        for (const target of this.targets) {
            this.player.engine.sendUpdatePacket(target, "PLAYER", [
                {
                    key: "isMarked",
                    value: false,
                    type: PacketValueSerialType.Bool
                }
            ]);
        }
    }

    onUse(): void {
        this.targets = this.player.engine.GetGameObjectsBehaviors<Player>(Player).filter(
            v => !v.isDead && v.team && v.team !== this.player.team
        );

        for (const target of this.targets) {
            this.player.engine.sendUpdatePacket(target, "PLAYER", [
                {
                    key: "isMarked",
                    value: true,
                    type: PacketValueSerialType.Bool
                }
            ]);
        }
    }
}